import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import _ from 'lodash';
// import '../resource/css/centerlogin.css';
import qs from 'query-string';
import ReactApexChart from 'react-apexcharts';
// import '../../resources/css/vaccineHelper.css';
import config from '../../config';


// TODO
// Error handle
// loading spinner
// possibly remove tools




class VaccineCumulativeChartV2 extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
            loading:true,
            series: [],
            options: {
                chart: {
                    height: '100%',
                    type: 'bar',
                    stacked: false
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        startingShape: 'flat',
                        endingShape: 'flat',
                        columnWidth: '35%',
                        barHeight: '70%',
                        distributed: false,
                        rangeBarOverlap: true,
                        colors: {
                            ranges: [{
                                
                                color: ['#ffc838']
                            }],
                            backgroundBarOpacity: 0.6,
                            backgroundBarRadius: 0,
                        },
                        
                    },
                },
                dataLabels: {
                    enabled: false
                },
                
                stroke: {
                    show: true,
                    curve: 'smooth',
                    lineCap: 'butt',
                    // colors: ['#5c5c5c'],
                    width: 3,
                    dashArray: 0,      
                },
            
                xaxis: {
                    type: 'datetime',
                    categories: [],
                    labels: {
                        datetimeFormatter: {
                            year: 'yyyy',
                            month: 'MMM dd',
                            day: 'MMM dd',
                        }
                    }
                    
                },
                
                
                legend: {
                    horizontalAlign: 'left',
                    offsetX: 0
                }
            },
      
      
      };
    }

    async loadOut(){
        const qValues = qs.parse(this.props.location.search);
        let formData;
        let qResp;
        let qData;
        let cleanDate=[];
        let cleanTotalCumulativeAACORes=[];
        let cleanTotal1stDose=[];
        let cleanTotal2ndDose=[];
        let cleanTotalBothDose=[];
        let cleanCasesPerDay=[];
        let cleanCasesMovingDay=[];
        let qWhere="1=1";
        let fieldMap;
        let url=config.apiv2.vaccine;;
        let offSwitch=false;
        let limitRecord=false;
        let ctRec=0;
        
        formData=new FormData();
        formData.append("where",qWhere);
        formData.append("outFields","*");
        formData.append("returnGeometry","false");
        formData.append("orderByFields","date");
        formData.append("returnDistinctValues","false");
        formData.append("f","json");

        try{
            qResp = await fetch(url+"/query",{method:"post",body:formData});
            qData = await qResp.json();
        }catch(err){
            console.log(err);
        }

        if(_.get(qData,"features.length",0)>0){
            _.forEach(qData.features,function(value,key){
                ctRec+=1;
                var validDate = (new Date(value.attributes.date)).getTime();
                let TotalCumulativeAACORes=value.attributes.TotalCumulative_AACORes;
                let total1stDose = value.attributes.Total1Dose_AACORes;
                let total2ndDose = value.attributes.Total2Doses_AACORes;
                
                cleanDate.push(validDate);
                cleanTotalCumulativeAACORes.push(TotalCumulativeAACORes);
                cleanTotal1stDose.push(total1stDose);
                cleanTotal2ndDose.push(total2ndDose);
                cleanTotalBothDose.push(total1stDose+total2ndDose);
            });
            let minTotalDose=Math.min.apply(Math, cleanTotalCumulativeAACORes);
            let maxTotalDose=Math.max.apply(Math, cleanTotalCumulativeAACORes);
            let minBothDose=Math.min.apply(Math, cleanTotalBothDose);
            let maxBothDose=Math.max.apply(Math, cleanTotalBothDose);

            this.setState({
                loading:false,
                error:false,
                series: [
                    {
                        name: 'Total Vaccines Administered',
                        type: 'line',
                        data: cleanTotalCumulativeAACORes
                    },
                    
                    {
                        name:'Daily Vaccines',
                        type:'bar',
                        data:cleanTotalBothDose
                    }
                ],
                options: {
                  ...this.state.options,
                  colors: ['#ffbe4f', '#0ea7b5'],
                  xaxis: {
                    ...this.state.options.xaxis,
                    categories:cleanDate,
                    
                  },
                  yaxis: [
                    {
                        seriesName: 'Total Vaccines Administered',
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                            // color: '#055a87'
                        },
                        labels: {
                            style: {
                            // colors: '#055a87',
                            },
                            formatter: function(value, timestamp, index) {
                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            }
                        },
                        title: {
                            text: "# of Vaccines Administered",
                        },
                        tooltip: {
                            enabled: false
                        }
                    },
                    {
                        seriesName:"Daily Vaccines",
                        show: true,
                        opposite: true,
                        min:minBothDose,
                        max:maxBothDose,
                        forceNiceScale:true,
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                            // color: '#ffc838'
                        },
                        labels: {
                            style: {
                                // colors: '#ffc838',
                            },
                            formatter: function(value, timestamp, index) {
                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            }
                        },
                        title: {
                            text: "Daily Vaccines",
                        }
                    },
                    
                    
                    
                ],
                tooltip: {
                    enabled: true,
                    enabledOnSeries: true,
                    shared: true,
                    followCursor: true,
                    intersect: false,
                    inverseOrder: true,
                    fillSeriesColor: false,
                    // theme: true,
                    style: {
                      fontSize: '11px',
                      //fontFamily: undefined
                    },
                    onDatasetHover: {
                        highlightDataSeries: false,
                    },
                   
                    y: [{
                            formatter: function(value, timestamp, index) {
                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            },
                            title: {
                                formatter: (seriesName) => seriesName,
                            },
                        },
                        {
                            formatter: function(value, timestamp, index) {
                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            },
                            title: {
                                formatter: (seriesName) => seriesName,
                            },
                        }],
                    
                    marker: {
                        show: true,
                    },
                },
                }
            });

            
        }else{
            // error handle
            this.setState({
                loading:false,
                error:true
            });
        }
    }

    componentDidMount(){
        this.loadOut();
    }

  

    // render() {
    //   return (
    //         <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
    //             <div id="chart" style={{height:"92vh",paddingRight:"0",paddingLeft:"0"}}>
    //                 <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={'100%'} />
    //             </div>
    //         </Container>
    //   );
    // }

    render() {
        if(this.state.loading===true){
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <div id="loader" style={{textAlign:"center"}}>
                        <Row>
                            <Col>
                                <Spinner animation="border" variant="primary" />
                            </Col>
                        </Row>
                    </div>
                </Container>
            );

        }else if(this.state.loading===false && this.state.error===true){
            //show error
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <Alert></Alert>
                </Container>
            );
        }else{
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <div id="chart" style={{height:"92vh",paddingRight:"0",paddingLeft:"0"}}>
                        <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={'100%'} />
                    </div>
                </Container>
            );
        }
    }
}

export default VaccineCumulativeChartV2;